import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=40d01a0b&scoped=true&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=40d01a0b&prod&lang=scss&scoped=true&"
import style1 from "./notification.vue?vue&type=style&index=1&id=40d01a0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d01a0b",
  null
  
)

export default component.exports